import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2d2bca0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "myAppPage" }
const _hoisted_2 = { class: "searchBar" }
const _hoisted_3 = { class: "searchBar" }

import { ref, watchEffect } from "vue";
import API from "@/api";
import { listMyAppVoByPageUsingPost } from "@/api/appController";
import message from "@arco-design/web-vue/es/message";
import { IconPlus } from "@arco-design/web-vue/es/icon";
import AddAppModal from "@/views/app/components/AddAppModal.vue";
import MyAppCard from "@/components/MyAppCard.vue";

// 初始化搜索条件

export default /*#__PURE__*/_defineComponent({
  __name: 'MyAppPage',
  setup(__props) {

const initSearchParams = {
  current: 1,
  pageSize: 10,
};

const searchParams = ref<API.AppQueryRequest>({
  ...initSearchParams,
});
const dataList = ref<API.AppVO[]>([]);
const total = ref<number>(0);

/**
 * 加载数据
 */
const loadData = async () => {
  const params = {
    ...searchParams.value,
  };
  const res = await listMyAppVoByPageUsingPost(params);
  if (res.data.code === 200) {
    dataList.value = res.data.data?.records || [];
    total.value = res.data.data?.total || 0;
  } else {
    message.error("获取数据失败，" + res.data.message);
  }
};
const doSearch = (value: string) => {
  searchParams.value.searchText = value;
  loadData();
};

/**
 * 当分页变化时，改变搜索条件，触发数据加载
 * @param page
 */
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};
const onPageSizeChange = (pageSize: number) => {
  searchParams.value = {
    ...searchParams.value,
    pageSize,
  };
};
/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
watchEffect(() => {
  loadData();
});
const addAppModal = ref();
const openAddAppModal = () => {
  addAppModal.value.openModal();
};

return (_ctx: any,_cache: any) => {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_list = _resolveComponent("a-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_input_search, {
        style: { width: '500px' },
        placeholder: "搜索应用",
        "button-text": "搜索",
        size: "large",
        "search-button": "",
        onSearch: doSearch
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: openAddAppModal
      }, {
        icon: _withCtx(() => [
          _createVNode(_unref(IconPlus))
        ]),
        default: _withCtx(() => [
          _createTextVNode(" 点击制作应用 ")
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_list, {
      class: "list-demo-action-layout",
      "grid-props": { gutter: [20, 20], sm: 24, md: 12, lg: 8, xl: 6 },
      bordered: false,
      data: dataList.value,
      "pagination-props": {
        showTotal: true,
        showPageSize: true,
        pageSize: searchParams.value.pageSize,
        current: searchParams.value.current,
        total: total.value,
      },
      onPageChange: onPageChange,
      onPageSizeChange: onPageSizeChange
    }, {
      item: _withCtx(({ item }) => [
        _createVNode(MyAppCard, { app: item }, null, 8, ["app"])
      ]),
      _: 1
    }, 8, ["data", "pagination-props"]),
    _createVNode(AddAppModal, {
      ref_key: "addAppModal",
      ref: addAppModal,
      "is-add": true
    }, null, 512)
  ]))
}
}

})